import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

// Modules
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
// import { CalendarModule } from 'ion2-calendar';
import { ColorPickerModule } from 'ngx-color-picker';

// Components
import { MenuComponent } from './components/menu/menu.component';
import { MenuItemDividerComponent } from './components/menu/item-divider/item-divider.component';
import { MenuItemOptionComponent } from './components/menu/item-option/item-option.component';
import { MenuItemTitleComponent } from './components/menu/item-title/item-title.component';
import { ProfileComponent } from './components/profile/profile.component';
import { FilterMenuComponent } from './components/filter-module/filter-menu/filter-menu.component';
import { FilterItemInputComponent } from './components/filter-module/filter-input/filter-input.component';
import { FilterItemCalendarComponent } from './components/filter-module/filter-calendar/filter-calendar.component';

//Services
import { ToastService } from './services/toast.service';
import { LoaderService } from './services/loader.service';
import { LayoutComponent } from './components/layout/layout.component';
import { FilterDataService } from './components/filter-module/filter-data.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DeviceAttributesComponent } from './components/device-attributes/device-attributes.component';
import { SensorIconComponent } from './components/sensor-icon/sensor-icon.component';
import { SensorLimitComponent } from './components/sensor-limit/sensor-limit.component';
import { SensorRangeComponent } from './components/sensor-limit/sensor-range.component';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { BillingSummaryComponent } from './components/billing-summary/billing-summary.component';
import { NgChartsModule } from 'ng2-charts';
import { UserAccessLogComponent } from '../views/main/superadmin/users/containers/user-access-log/user-access-log.component';
import { StackSettingsComponent } from './components/stack-settings/stack-settings.component';
import { InfoStackComponent } from './components/info-stack/info-stack.component';
import { GraphBatteryCoverageComponent } from './components/graph-battery-coverage/graph-battery-coverage.component';
import { DevicesService } from '../views/main/superadmin/services/devices.service';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    RouterModule,
    TranslateModule,
    MaterialModule,
    // CalendarModule,
    MatProgressBarModule,
    ColorPickerModule,
    NgChartsModule


  ],
  declarations: [
    MenuComponent,
    MenuItemDividerComponent,
    MenuItemOptionComponent,
    MenuItemTitleComponent,
    ProfileComponent,
    LayoutComponent,
    FilterMenuComponent,
    FilterItemInputComponent,
    FilterItemCalendarComponent,
    DeviceAttributesComponent,
    SensorLimitComponent,
    SensorRangeComponent,
    SensorIconComponent,
    DeleteModalComponent,
    BillingSummaryComponent,
    UserAccessLogComponent,
    StackSettingsComponent,
    InfoStackComponent,
    GraphBatteryCoverageComponent,

  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    IonicModule,
    MaterialModule,
    ReactiveFormsModule,
    TranslateModule,
    MenuComponent,
    ProfileComponent,
    LayoutComponent,
    FilterMenuComponent,
    DatePipe,
    MatProgressBarModule,
    SensorIconComponent,
    BillingSummaryComponent,
    NgChartsModule,
    UserAccessLogComponent,
    StackSettingsComponent,
    InfoStackComponent,
    GraphBatteryCoverageComponent,
  ],

  providers: [
    LoaderService,
    ToastService,
    FilterDataService,
    DevicesService
  ]
})
export class SharedModule { }